import React from 'react';
import { Flex, Stack, Switch, Text, Textarea } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  inclusionCondition: string | null | undefined;
  onChange: (inclusionCondition: string | null) => void;
};

export function ConditionalSectionSettings({ inclusionCondition, onChange }: Props) {
  const isConditional = inclusionCondition != null;
  const isBlank = isConditional && inclusionCondition.trim() === '';

  return (
    <Stack gap="xs" p="sm" bg="gray.0" style={{ borderRadius: '8px', minWidth: 0 }}>
      <Flex align="center" justify="space-between" gap="sm" style={{ minWidth: 0 }}>
        <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.8" style={{ minWidth: 0 }} truncate>
          Conditional section
        </Text>
        <Switch
          checked={isConditional}
          onChange={event => onChange(event.currentTarget.checked ? '' : null)}
          aria-label="Conditional section"
        />
      </Flex>
      {isConditional && (
        <Textarea
          label="Include this section only when…"
          description="Siesta checks this against the client's details and preparation documents before drafting. If it isn't met, the section and its heading are left out. If it can't tell, the section is kept and flagged for the adviser. Don't repeat this condition in the instructions."
          placeholder="e.g. the client is aged 80 or over"
          value={inclusionCondition}
          onChange={event => onChange(event.currentTarget.value)}
          error={isBlank ? 'Write the condition, or switch this off' : undefined}
          autosize
          minRows={2}
          size="sm"
        />
      )}
    </Stack>
  );
}
